// Centralized brand constants
export const BRAND = {
  fullName: "Pro Skate Hockey League",
  short: "PSHL",
  digital: "PSHL8",
  tagline: "Power • Speed • Hustle • Legacy",
  subTagline: "Infinite Performance",
  whatsapp: "https://wa.me/919999000000?text=Hi%20PSHL8%2C%20I%27d%20like%20to%20learn%20more.",
  email: "partnerships@pshl8.in",
  phone: "+91 99990 00000",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Teams", to: "/teams" },
  { label: "Schedule", to: "/schedule" },
  { label: "Standings", to: "/standings" },
  { label: "Players", to: "/players" },
  { label: "News", to: "/news" },
  { label: "Sponsorships", to: "/sponsorships" },
  { label: "Partnerships", to: "/partnerships" },
  { label: "Academies", to: "/academies" },
  { label: "Media", to: "/media" },
  { label: "Contact", to: "/contact" },
];

// Pillar background images are served from the backend (AI-generated via Gemini Nano Banana).
// Falls through to the previous Unsplash URL while generation is in progress (the <img>
// onError fallback inside Home.jsx handles the missing-state cleanly).
const PILLAR_IMG = (key) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/pillars/${key}`;

export const PILLARS = [
  { key: "speed",       title: "Speed",       desc: "Velocity defines our game. Every pass, every play, every second.",
    image: PILLAR_IMG("speed"),
    fallback: "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1200&q=70&auto=format&fit=crop" },
  { key: "skill",       title: "Skill",       desc: "Mastered fundamentals. World-class craft. Indian grit.",
    image: PILLAR_IMG("skill"),
    fallback: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=1200&q=70&auto=format&fit=crop" },
  { key: "strength",    title: "Strength",    desc: "Built bodies. Built belief. Built for the league.",
    image: PILLAR_IMG("strength"),
    fallback: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=1200&q=70&auto=format&fit=crop" },
  { key: "strategy",    title: "Strategy",    desc: "Coaching depth, analytics, and championship play-books.",
    image: PILLAR_IMG("strategy"),
    fallback: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=1200&q=70&auto=format&fit=crop" },
  { key: "stamina",     title: "Stamina",     desc: "Three periods. Zero compromise. Pure endurance.",
    image: PILLAR_IMG("stamina"),
    fallback: "https://images.unsplash.com/photo-1530549387789-4c1017266635?w=1200&q=70&auto=format&fit=crop" },
  { key: "spirit",      title: "Spirit",      desc: "City pride. Fan culture. The roar that fuels every shift.",
    image: PILLAR_IMG("spirit"),
    fallback: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200&q=70&auto=format&fit=crop" },
  { key: "showmanship", title: "Showmanship", desc: "Arena lighting, anthems, fan-cams — sports as spectacle.",
    image: PILLAR_IMG("showmanship"),
    fallback: "https://images.unsplash.com/photo-1577471488278-16eec37ffcc2?w=1200&q=70&auto=format&fit=crop" },
  { key: "success",     title: "Success",     desc: "Trophies, careers, brands, communities — built together.",
    image: PILLAR_IMG("success"),
    fallback: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=1200&q=70&auto=format&fit=crop" },
];


/* ────────────────────────────────────────────────────────────────
 * Sticky Sponsor CTA — A/B variants
 *   Change SPONSOR_CTA_ACTIVE in this one line to flip the headline
 *   used by <SponsorStickyCTA>.
 *     "a"      → "Become a PSHL Sponsor"
 *     "b"      → "Title Sponsor Slot Open"
 *     "c"      → "Sponsor PSHL8 — Reach 1.4B"
 *     "random" → pick a random variant per browser session (real A/B)
 *   Want a new option? Add a row to SPONSOR_CTA_VARIANTS below.
 * ──────────────────────────────────────────────────────────────── */
export const SPONSOR_CTA_ACTIVE = "a"; // ← EDIT THIS LINE

export const SPONSOR_CTA_VARIANTS = {
  a: {
    eyebrow:  "PSHL8 · Sponsor Inventory Open",
    headline: "Become a PSHL Sponsor",
    subtext:  "9 sponsorship tracks. Pan-India broadcast + on-ground visibility.",
    cta:      "Request Partnership Call",
  },
  b: {
    eyebrow:  "Inaugural Season · Bidding Open",
    headline: "Title Sponsor Slot Open",
    subtext:  "Centre-ice, jerseys, broadcast title card. League naming rights up for bid.",
    cta:      "Submit Title Bid",
  },
  c: {
    eyebrow:  "Reach 1.4 Billion",
    headline: "Sponsor PSHL8 — Reach 1.4B",
    subtext:  "Premium franchise sport. CSR-aligned. Youth-engaged. Broadcast-ready.",
    cta:      "Talk to Partnerships",
  },
};
